// GUT HEALTH section — all 2026 assets (Gut Health folder + jpgs/).
import { pdf2026, thumb2026 } from "./assets";

const CAT = "Gut Health";
const card = (title, file, thumb) => ({
  title,
  pdf: pdf2026(CAT, `${file}.pdf`),
  thumb: thumb2026(`${thumb || file}.jpg`),
});

const gutHealthCards = [
  card("Guide to Inflammatory Bowel Disease", "Guide to Inflammatory Bowel Disease"),
  card("Eating More Soluble Fiber", "Eating More Soluble Fiber"),
  card("Your 30 Plants a Week Worksheet", "Your 30 Plants a Week Worksheet"),
  card("Tips to Reach 30 Plant Servings a Week", "Tips to Reach 30 Plant Servings a Week"),
  card("30 Plants a Week Food Menu", "30 Plants a Week Food Menu"),
  card("Managing Constipation", "Managing Constipation"),
];

export default gutHealthCards;
